export default "__VITE_ASSET__CIUcJ0uh__"